import NotFoundContent from '../../components/Container/NotFoundContent/NotFoundContent'

const NotFound = () => {
    return (
        <div>
            <NotFoundContent />
        </div>
    )
}

export default NotFound